module.exports = __webpack_public_path__ + "static/project-18a-c616a55ff3dc2a7e48dc6945bf22b630.png";